import { AxiosResponse } from 'axios';
import instance from '../../api/instance';
import { PhyDevice, PhyDeviceUpdate } from './types';

export type GetPhyDevices = (params: { query?: string }) => Promise<AxiosResponse<PhyDevice[]>>;

export const fetchPhyDevicesApi: GetPhyDevices = async params => {
  return instance.get<PhyDevice[]>(`devices`, { params }).catch(e => e.response as never);
};

export type GetPhyDevice = (deviceId: string) => Promise<AxiosResponse<PhyDevice>>;

export const fetchPhyDeviceApi: GetPhyDevice = async (deviceId: string) => {
  return instance.get<PhyDevice>(`devices/${deviceId}`).catch(e => e.response as never);
};
export const updatePhyDeviceApi = async ({
  deviceId,
  data,
}: {
  deviceId: string;
  data: PhyDeviceUpdate;
}): Promise<AxiosResponse<PhyDevice>> => {
  return instance.post<PhyDevice>(`devices/${deviceId}`, data).catch(e => e.response as never);
};
